
import { useMemo } from "react";
import { PersonOption } from "../types/AssignPerson.types";
import { useGetSalesEmployeesQuery } from "../store/services/customerService";

// Hook för säljare
export const useSalesPersons = () => {
  const { data: employees = [], isLoading, error } = useGetSalesEmployeesQuery();

  const persons: PersonOption[] = useMemo(() => 
    employees.map(employee => ({
      id: employee.ExternalUserNo,
      name: employee.Name,
      title: employee.ContactPersonData?.Title,
      avatar: employee.ContactPersonData?.ImageData 
        ? `data:image/png;base64,${employee.ContactPersonData.ImageData}`
        : undefined,
    })), [employees]
  );

  return {
    persons,
    isLoading,
    error,
  };
};
